import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { useSecurityHeaders } from "./hooks/useSecurityHeaders";

// Apply security headers immediately
const SecurityWrapper = () => {
  useSecurityHeaders();
  return <App />;
};

createRoot(document.getElementById("root")!).render(<SecurityWrapper />);
